module.exports = __webpack_public_path__ + "static/img/3.6a56cde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/3.png
// module id = rqFn
// module chunks = 0